export const LOAD_OVERVIEW_CONTACT = 'overviewContact/LOAD_OVERVIEW_CONTACT';
